module.exports = __webpack_public_path__ + "img/mangosalsa.2f72438e.jpg";